import React from 'react'
import { Blocks, Laptop, TabletSmartphone, Network, MonitorCog } from 'lucide-react'

function Counter({count, icon, text, yrs}) {
    return (
        <div className="z-40 p-3 gap-3 relative w-full rounded-lg flex justify-center items-center flex-col">
            <div className={`flex items-${yrs ? "end" : "center"}`}>
                <h1 className='text-4xl lg:text-6xl bg-clip-text text-transparent bg-gradient-to-b from-neutral-200 to-neutral-600  text-center font-sans font-bold'>
                    {count}
                </h1>
                {
                    yrs ? <span className='text-blue-500 text-xl lg:text-3xl font-extrabold mt-auto'>Yrs</span>
                    :
                    <span className='text-blue-500 text-3xl lg:text-5xl mt-2 font-extrabold'>+</span>
                }
                
            </div>
            <div className='flex items-center gap-1 p-2 rounded-lg bg-transparent lg:bg-gray-800 xl:bg-gray-800'>
                {icon}
                <h1 className='text-[0.5em] xl:text-xs lg:text-xs'>{text}</h1>
            </div>
        </div>
    )
}

export default Counter